module.exports = __webpack_public_path__ + "media/images/icons/floorplan-0c5606329b336875ca7a65d9e47ef38d.svg";